/**
 * Long-stay Q&A cluster (Non-O/O-A/O-X, LTR, Thailand Privilege, PR).
 * Deterministic generator — no service prices, official fees only where published.
 */
import { LONGSTAY_SERVICES, LONGSTAY_COUNTRIES } from "./index";
import { liftFlatToFloor } from "../_qa/topup-merge";
import { LONGSTAY_TOPUP_AXIS } from "../_qa/topup-axes-2";

export type LongstayQA = {
  slug: string;
  q: string;
  a: string;
  synonyms: string[];
  serviceSlug?: string;
};

export const LONGSTAY_REVIEWED_TH = "สิงหาคม 2569";
export const LONGSTAY_REVIEWED_ISO = "2026-08-06T00:00:00.000Z";

const ASOF = `ข้อมูลทบทวน ณ ${LONGSTAY_REVIEWED_TH} หลักเกณฑ์ ระยะเวลา และเอกสารอาจเปลี่ยนตามประกาศของสำนักงานตรวจคนเข้าเมือง สถานทูตไทย BOI หรือ Thailand Privilege ควรตรวจประกาศล่าสุดก่อนยื่น เว็บไซต์ไม่แสดงค่าบริการ กรุณาสอบถามทางโทรศัพท์ LINE หรืออีเมล`;

const CORE: LongstayQA[] = [
  {
    slug: "longstay-choose-route",
    q: "ควรเลือกวีซ่าอยู่ระยะยาวแบบไหนระหว่าง Non-O เกษียณ LTR Thailand Privilege และ PR",
    a: `เลือกจากคุณสมบัติจริง ไม่ใช่จากระยะเวลาวีซ่า Non-O เกษียณเหมาะกับผู้มีอายุตามเกณฑ์และมีหลักฐานการเงินในไทย LTR พิจารณาจากรายได้ สินทรัพย์ หรือสถานะการจ้างงานตามหลักเกณฑ์ BOI Thailand Privilege เป็นสมาชิกภาพที่ให้สิทธิพำนักตามแพ็กเกจ และถิ่นที่อยู่ถาวรต้องมีประวัติต่อวีซ่าต่อเนื่องและเข้าเงื่อนไขโควตาประจำปี ควรประเมินเอกสารการเงิน แผนทำงาน และครอบครัวก่อนตัดสินใจ ${ASOF}`,
    synonyms: ["เปรียบเทียบวีซ่าอยู่ยาวไทย", "retirement visa vs LTR vs elite"],
  },
  {
    slug: "longstay-financial-evidence",
    q: "หลักฐานการเงินสำหรับวีซ่าอยู่ระยะยาวต้องเตรียมอย่างไร",
    a: `ต้องเตรียมหลักฐานที่ตรวจสอบย้อนกลับได้ เช่น สมุดบัญชีและหนังสือรับรองยอดจากธนาคารในไทย หลักฐานรายได้หรือบำนาญจากต้นทาง และเอกสารแสดงเส้นทางการโอนเงินเข้าประเทศ จำนวนเงิน ระยะเวลาที่ต้องคงยอด และรูปแบบเอกสารกำหนดโดยหน่วยงานที่พิจารณา ห้ามใช้เอกสารที่จัดทำขึ้นเองหรือยอดที่ยืมมาแสดงชั่วคราว เพราะเป็นเหตุให้ปฏิเสธและมีผลต่อการยื่นครั้งถัดไป ${ASOF}`,
    synonyms: ["เงินฝาก 800000 วีซ่าเกษียณ", "financial evidence long stay Thailand"],
  },
  {
    slug: "longstay-documents-from-abroad",
    q: "เอกสารจากต่างประเทศที่ใช้ขอวีซ่าอยู่ระยะยาวต้องรับรองอะไรบ้าง",
    a: `โดยทั่วไปต้องมีคำแปลที่ถูกต้องและผ่านการรับรองตามที่หน่วยงานปลายทางกำหนด เอกสารบางประเภทต้องผ่านการรับรองจากหน่วยงานต้นทางและกรมการกงสุลก่อนใช้ในไทย ค่าธรรมเนียมนิติกรณ์ของกรมการกงสุลตามที่ประกาศคือ 200 บาทต่อตราประทับสำหรับบริการปกติ และ 400 บาทต่อตราประทับสำหรับบริการด่วน ควรตรวจข้อกำหนดของหน่วยงานที่รับเรื่องก่อนแปลเพื่อไม่ต้องทำซ้ำ ${ASOF}`,
    synonyms: ["รับรองเอกสารต่างประเทศใช้ขอวีซ่าไทย", "legalisation documents long stay"],
  },
  {
    slug: "longstay-apostille-2027",
    q: "ไทยเข้าอนุสัญญา Apostille แล้วจะกระทบการเตรียมเอกสารวีซ่าอยู่ยาวหรือไม่",
    a: `อนุสัญญา Apostille มีผลกับประเทศไทยวันที่ 28 กุมภาพันธ์ 2570 หลังจากนั้นเอกสารระหว่างประเทศภาคีอาจใช้ Apostille แทนการรับรองซ้อนหลายชั้นได้ แต่ยังต้องผ่านคำแปลและการตรวจสอบตามที่หน่วยงานปลายทางกำหนด สำหรับประเทศที่ไม่ใช่ภาคียังใช้เส้นทางรับรองแบบเดิม หากยื่นก่อนวันมีผล ให้ทำตามแนวทางปัจจุบัน ${ASOF}`,
    synonyms: ["Apostille ไทย 2570 วีซ่า", "apostille Thailand effect long stay"],
  },
  {
    slug: "longstay-reporting-duties",
    q: "ได้วีซ่าอยู่ระยะยาวแล้วยังต้องรายงานตัวและแจ้งที่พักหรือไม่",
    a: `ยังมีหน้าที่ตามกฎหมายคนเข้าเมือง ได้แก่ การแจ้งที่พักโดยเจ้าบ้านหรือผู้ครอบครองเมื่อมีคนต่างชาติเข้าพัก และการรายงานที่อยู่ทุก 90 วันสำหรับผู้พำนักต่อเนื่อง เงื่อนไขและช่องทางของแต่ละประเภทวีซ่าไม่เหมือนกัน การขาดรายงานเป็นเหตุให้เสียค่าปรับและกระทบการต่ออายุ ควรบันทึกกำหนดวันและเก็บใบรับทุกครั้ง ${ASOF}`,
    synonyms: ["รายงานตัว 90 วัน LTR", "TM30 TM47 long stay obligations"],
  },
  {
    slug: "longstay-rejection-reasons",
    q: "คำขอวีซ่าอยู่ระยะยาวถูกปฏิเสธเพราะสาเหตุอะไรบ่อยที่สุด",
    a: `สาเหตุที่พบบ่อยคือหลักฐานการเงินไม่ครบระยะเวลาที่กำหนด เอกสารต้นทางไม่ผ่านการรับรองที่ถูกต้อง ชื่อสะกดไม่ตรงกับหนังสือเดินทาง ที่พักไม่ตรงกับที่แจ้งไว้ ประวัติ overstay และเอกสารหมดอายุระหว่างพิจารณา ควรตรวจสอบชุดเอกสารทั้งชุดพร้อมกันก่อนยื่น และเผื่อเวลาสำหรับการขอเอกสารซ้ำ ${ASOF}`,
    synonyms: ["วีซ่าเกษียณถูกปฏิเสธ", "long stay visa refusal reasons Thailand"],
  },
];

function serviceQA(s: (typeof LONGSTAY_SERVICES)[number]): LongstayQA[] {
  const rows: Array<[string, string, string]> = [
    ["what", `${s.nameTh} คืออะไรและเหมาะกับใคร`, `${s.nameTh} (${s.nameEn}) เหมาะกับกรณี ${s.intent} หน่วยงานที่พิจารณาหลักคือ ${s.gov} กรอบเวลาดำเนินการโดยทั่วไปประมาณ ${s.turnaround} ซึ่งขึ้นกับคิว ความครบถ้วนของเอกสาร และดุลพินิจของเจ้าหน้าที่ ${ASOF}`],
    ["documents", `${s.nameTh} ต้องเตรียมเอกสารอะไร`, `ชุดเอกสารตั้งต้นได้แก่ หนังสือเดินทางและหน้าวีซ่าปัจจุบัน หลักฐานที่พักในไทย หลักฐานการเงินหรือรายได้ตามหลักเกณฑ์ของ ${s.gov} รูปถ่ายตามรูปแบบที่กำหนด และแบบคำขอที่กรอกครบถ้วน เอกสารต่างประเทศต้องมีคำแปลและการรับรองตามที่ผู้พิจารณากำหนด ${ASOF}`],
    ["steps", `${s.nameTh} มีขั้นตอนอย่างไร`, `เริ่มจากตรวจคุณสมบัติและสถานะวีซ่าปัจจุบัน จัดเตรียมและรับรองเอกสาร ยื่นคำขอต่อ ${s.gov} เข้ารับการสัมภาษณ์หรือให้ข้อมูลเพิ่มเติมหากถูกเรียก แล้วรับผลและตรวจตราประทับหรือเงื่อนไขที่ระบุ ก่อนเดินทางออกนอกประเทศให้ตรวจเรื่องสิทธิกลับเข้าประเทศทุกครั้ง ${ASOF}`],
    ["timeline", `${s.nameTh} ใช้เวลานานเท่าไร`, `กรอบเวลาอ้างอิงประมาณ ${s.turnaround} นับจากยื่นเอกสารครบ แต่ ${s.gov} อาจใช้เวลามากกว่านั้นเมื่อมีการขอเอกสารเพิ่ม ตรวจสอบข้อมูลข้ามหน่วยงาน หรืออยู่ในช่วงคิวหนาแน่น ไม่ควรจองตั๋วหรือทำสัญญาผูกพันก่อนได้ผลอนุมัติ ${ASOF}`],
    ["risks", `${s.nameTh} มีข้อควรระวังอะไร`, `ข้อควรระวังคือการยื่นเมื่อวีซ่าเดิมใกล้หมดอายุจนไม่มีเวลาแก้เอกสาร การใช้ยอดเงินที่ไม่คงอยู่ตามระยะเวลา การแจ้งที่พักไม่ตรงความจริง และการเข้าใจว่าอนุมัติแล้วไม่ต้องรายงานตัวอีก ทุกกรณีให้ยึดประกาศของ ${s.gov} เป็นหลัก ${ASOF}`],
    ["quote", `${s.nameTh} คิดค่าบริการอย่างไร`, `ค่าบริการประเมินเป็นรายเคสตามความซับซ้อนของเอกสาร จำนวนผู้ยื่น สถานะวีซ่าเดิม และงานแปลหรือรับรองที่ต้องทำ เว็บไซต์จึงไม่แสดงราคาเหมารวม ค่าธรรมเนียมราชการเป็นไปตามอัตราที่หน่วยงานประกาศและชำระตรงต่อหน่วยงาน สอบถามขอบเขตงานได้ทางโทรศัพท์ LINE หรืออีเมล ${ASOF}`],
  ];
  return rows.map(([suffix, q, a]) => ({
    slug: `${s.slug}-${suffix}`,
    q,
    a,
    synonyms: [`${s.nameTh} ${suffix}`, `${s.nameEn.toLowerCase()} ${suffix}`],
    serviceSlug: s.slug,
  }));
}

function matrixQA(): LongstayQA[] {
  const out: LongstayQA[] = [];
  for (const s of LONGSTAY_SERVICES) {
    for (const c of LONGSTAY_COUNTRIES) {
      out.push({
        slug: `${s.slug}-${c.slug}-docs`,
        q: `ผู้ถือสัญชาติ${c.nameTh}ยื่น ${s.nameTh} ต้องเตรียมเอกสารต่างจากคนชาติอื่นอย่างไร`,
        a: `ผู้ถือหนังสือเดินทาง${c.nameTh} (${c.nameEn}) ต้องตรวจว่าหน่วยงานต้นทางออกหลักฐานรายได้ บำนาญ หรือประวัติอาชญากรรมในรูปแบบใด และหน่วยงานนั้นยังออกเอกสารประเภทนั้นอยู่หรือไม่ หากไม่ออกให้ ต้องใช้ชุดหลักฐานทางเลือกที่ ${s.gov} ยอมรับ เอกสารต้องมีคำแปลและการรับรองครบชั้นก่อนยื่น ${ASOF}`,
        synonyms: [`${s.nameTh} ${c.nameTh}`, `${s.nameEn} ${c.nameEn} documents`],
        serviceSlug: s.slug,
      });
      out.push({
        slug: `${s.slug}-${c.slug}-process`,
        q: `ผู้ถือสัญชาติ${c.nameTh}ควรเริ่ม ${s.nameTh} จากขั้นตอนใด`,
        a: `เริ่มจากตรวจสถานะการเข้าเมืองปัจจุบันและวันหมดอายุ จากนั้นขอเอกสารต้นทางใน${c.nameTh}ซึ่งมักใช้เวลานานที่สุด แปลและรับรองตามเส้นทางที่หน่วยงานปลายทางกำหนด แล้วจึงยื่นต่อ ${s.gov} โดยเผื่อเวลาไว้สำหรับการขอเอกสารเพิ่มเติม กรอบเวลาอ้างอิงประมาณ ${s.turnaround} ${ASOF}`,
        synonyms: [`${s.nameTh} ขั้นตอน ${c.nameTh}`, `${s.nameEn} process ${c.nameEn}`],
        serviceSlug: s.slug,
      });
    }
  }
  return out;
}

export const LONGSTAY_QA_ALL: LongstayQA[] = (() => {
  const all = [...CORE, ...LONGSTAY_SERVICES.flatMap(serviceQA), ...matrixQA()];
  const seen = new Set<string>();
  return all.filter((x) => (seen.has(x.slug) ? false : (seen.add(x.slug), true)));
})();

liftFlatToFloor(LONGSTAY_QA_ALL, {
  prefix: "longstay-t7",
  asOf: `ข้อมูลทบทวน ณ ${LONGSTAY_REVIEWED_TH} หลักเกณฑ์และเอกสารเปลี่ยนได้ตามประกาศของหน่วยงาน ควรตรวจก่อนยื่น เว็บไซต์ไม่แสดงค่าบริการ กรุณาสอบถามทางโทรศัพท์ LINE หรืออีเมล`,
  authorityTh: "สำนักงานตรวจคนเข้าเมืองและสถานทูตหรือสถานกงสุลที่เกี่ยวข้อง",
  clusterTh: "งานวีซ่าพำนักระยะยาวในไทย",
  primary: LONGSTAY_TOPUP_AXIS,
});

export const LONGSTAY_QA_BY_SLUG: Record<string, LongstayQA> = Object.fromEntries(
  LONGSTAY_QA_ALL.map((x) => [x.slug, x]),
);

export const LONGSTAY_QA_PHRASING_COUNT = LONGSTAY_QA_ALL.reduce(
  (n, qa) => n + 1 + qa.synonyms.length,
  0,
);
